// extracted by mini-css-extract-plugin
export default {"semi-bold":"CancelSchedulePrompt_semi-bold__oLknG"};